export default "__VITE_ASSET__u6Sq2zGC__"